import {
  Exercise,
  Lecture,
  Tutorial,
  Section,
  NoTimeExercise,
  StaffExercise,
} from 'Utils/TutorialConfigHelper';
import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import timestamps from './level13.json';

const Level13 = Tutorial(13, '1:15', [
  Section([
    Lecture('Building Harmony in 3/4', '0:0'),
    Exercise(
      'Hands Separate + Together',
      '0:24',
      NoTimeExercise({
        centre_align_horizontal: true,
        objectives: [
          {
            formatConfig: { first_note_offset: 50 },
          },
          {
            formatConfig: { first_note_offset: 50 },
          },
        ],
      }),
      [],
    ),
    Exercise(
      'Playing in Time',
      '0:37',
      StaffExercise({
        objectives: [{}, {}],
      }),
      [],
    ),
  ]),
  Section([
    Lecture('Hands Together', '0:48'),
    Exercise(
      'Hands Together',
      '1:03',
      StaffExercise({
        objectives: [{}, {}],
      }),
      [],
    ),
  ]),
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level13);
